module.exports = __webpack_public_path__ + "img/logo.d3751b95.png";